module.exports = __webpack_public_path__ + "images/landing/bg-5797a5f452d93ef38c06ed38f51f5cc0.png";